export default import.meta.ROLLDOWN_FILE_URL_K$6UhBpQKwz9BGvGCbTiow